
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.3432 10.5C2.90562 13.6151 6.19567 15.7597 9.99999 15.7597C13.8043 15.7597 17.0944 13.6151 18.6568 10.5C17.0944 7.38489 13.8043 5.2403 9.99999 5.2403C6.19567 5.2403 2.90562 7.38489 1.3432 10.5ZM0.0563144 10.2453C1.76282 6.56447 5.57246 4 9.99999 4C14.4275 4 18.2371 6.56447 19.9436 10.2453C20.0188 10.4073 20.0188 10.5927 19.9436 10.7547C18.2371 14.4356 14.4275 17 9.99999 17C5.57246 17 1.76282 14.4355 0.0563144 10.7547C-0.0187715 10.5927 -0.0187715 10.4073 0.0563144 10.2453ZM9.99999 8.17923C8.68097 8.17923 7.61182 9.21794 7.61182 10.4994C7.61182 11.7809 8.68097 12.8196 9.99999 12.8196C11.319 12.8196 12.3882 11.7809 12.3882 10.4994C12.3882 10.1569 12.674 9.87926 13.0265 9.87926C13.379 9.87926 13.6648 10.1569 13.6648 10.4994C13.6648 12.4659 12.0241 14.0599 9.99999 14.0599C7.97591 14.0599 6.33519 12.4659 6.33519 10.4994C6.33519 8.53294 7.97591 6.93893 9.99999 6.93893C10.3525 6.93893 10.6383 7.21657 10.6383 7.55908C10.6383 7.90157 10.3525 8.17923 9.99999 8.17923Z","fill":"#8338EC"}})])
          )
        }
      }
    